module.exports = __webpack_public_path__ + "img/menu_DASHBOARD.6c836ad5.svg";